import { LoadableLazy } from '@confluence/loadable';

export const PublishModalMountPoint = LoadableLazy({
	loader: async () => {
		return (
			await import(
				/* webpackChunkName: "loadable-PublishModalMountPoint" */ '../src/PublishModalMountPoint.tsx'
			)
		).PublishModalMountPoint;
	},
});
